<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Medicine Park</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgment">Acknowledgment</a></li>
<li id="toc-li-5"><a href="#/text/ch005#storm-clouds">Storm Clouds</a></li>
<li id="toc-li-6"><a href="#/text/ch006#thunderbolts">Thunderbolts</a></li>
<li id="toc-li-7"><span href="#/text/ch007#scattered-showers" title="Link target outside of Sample">Scattered Showers</span></li>
<li id="toc-li-8"><span href="#/text/ch008#partial-clearing" title="Link target outside of Sample">Partial Clearing</span></li>
<li id="toc-li-9"><span href="#/text/ch009#revised-forecast" title="Link target outside of Sample">Revised Forecast</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?22eca35a